import { LayoutConfiguration } from '@/moment/layouts/LayoutConfiguration/layout-configuration-factory.ts';
import { LightboxItem, adjustFotoscapesLink, } from '@/moment/net/softbox-types.ts';
import eventBus from '@/utils/eventsbus.ts';
import { BridgeInternalEvents } from '@/moment/bridge/bridge-internal-event-defs.ts';
import { AnalyticsService } from '@moment/analytics/AnalyticsService.ts';
import { getIsLinkExternal } from '@components/FotoscapeLink/utils.ts';
import { trackInterest } from '@moment/local-personalization/scorer.ts';
import { getCurrentNumberOfInteractions } from '@moment/local-personalization/scorer.ts';

export const filterLayoutConfiguration = (
  pageParams: Record<string, string>
) => {
  return (element: LayoutConfiguration) => {
    if (!element.filterOut) {
      return true;
    }
    const filterOut = element.filterOut;
    const filterOutKeys = Object.keys(filterOut);
    const pageParamsKeys = Object.keys(pageParams);
    //the below statement is for making the filterOut using a logical AND
    if (filterOutKeys.length !== pageParamsKeys.length) {
      return true;
    }
    for (const key of filterOutKeys) {
      if (!(key in pageParams) || filterOut[key] !== pageParams[key]) {
        return true;
      }
    }
    return false;
  };
};

export const onItemClicked = (
  item: LightboxItem,
  analytics: AnalyticsService,
  partner: string,
  link: string,
  language: string,
  searchParams: URLSearchParams,
  schedule?: string,
  source?: string,
  sourceSchedule: string = 'unapplicable'
) => {
  return () => {
    eventBus.emit(BridgeInternalEvents.LINK_CLICK, {
      interestId: item.interests[0],
      id: item.uid,
    });
    const isLinkExternal = getIsLinkExternal(adjustFotoscapesLink(link));

    if (isLinkExternal && item.interests && item.interests.length > 0) {
      trackInterest(item.interests, 'click');
    }

    analytics.emitContentClickedEvent({
      numInteractions: getCurrentNumberOfInteractions(),
      partnerId: partner,
      contentId: item.uid,
      type: isLinkExternal ? 'external' : 'internal',
      originUrl: window.location.href,
      destinationUrl: link,
      title: item.title?.en || '',
      contentOwner: item.owner,
      primaryInterest: item.interests[0],
      language,
      searchParams,
      source: source || '',
      sourceSchedule,
      schedule,
    });
  };
};

export const shuffleArray = (array: any[], promote: boolean = false): any[] => {
  if (array.length < 2) {
    return array;
  }
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  if (promote) {
    array.sort((a, b) => {return (a.promote && !b.promote ? -1 : 1)});
  }
  return array;
};
